import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { waLink } from "../../lib/api";

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-navy text-white py-20 md:py-28" data-testid="final-cta">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/6585757/pexels-photo-6585757.jpeg?auto=compress&cs=tinysrgb&w=1920)",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/80 to-navy/40" />
      <div className="container-site relative z-10 max-w-3xl">
        <p className="accent-script text-gold text-2xl mb-2">Bir sonraki adım</p>
        <h2 className="heading-serif text-3xl md:text-5xl font-semibold leading-tight mb-5">
          Otel Projeniz İçin Ücretsiz<br />Ekipman Danışmanlığı Alın
        </h2>
        <p className="text-white/75 max-w-xl leading-relaxed mb-8 text-base">
          Uzman ekibimiz projenize özel oda bazlı ekipman listesi hazırlar, yıldız standardınıza uygun
          alternatifler sunar ve 24 saat içinde detaylı teklifinizi oluşturur.
        </p>
        <div className="flex flex-wrap gap-3">
          <Link to="/iletisim" className="btn-gold" data-testid="final-cta-contact">
            Ücretsiz Danışmanlık <ArrowRight size={16} />
          </Link>
          <a
            href={waLink("Merhaba, otel projem için danışmanlık almak istiyorum.")}
            target="_blank"
            rel="noreferrer"
            className="btn-outline-white"
            data-testid="final-cta-whatsapp"
          >
            <MessageCircle size={16} /> WhatsApp ile Yaz
          </a>
        </div>
      </div>
    </section>
  );
}
